import { Typography } from '@mui/material';
import { DateFormat } from 'app/enums';
import React, { FC } from 'react';
import { DateTimeFormat } from 'shared/components/Format/DateTimeFormat';

interface TournamentTileDateProps {
  startedAt: string;
}

export const TournamentTileDate: FC<TournamentTileDateProps> = ({ startedAt }) => {
  if (!startedAt) {
    return null;
  }

  return (
    <Typography variant="subtitle2" textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
      <DateTimeFormat date={startedAt} format={DateFormat.DdMmmHhMm} />
    </Typography>
  );
};
